import { useDarkMode } from "@/hooks/useDarkMode";
import { CheckCircle, Info, Trash2, TriangleAlert } from "lucide-react";
import Modal from "react-responsive-modal";
import "react-responsive-modal/styles.css";

interface ModalProps {
  isModalOpen: boolean;
  title: string;
  subtitle: string;
  cancelButtonTitle: string;
  actionButtonTitle: string;
  actionButtonType: "default" | "error" | "warning";
  type: "default" | "error" | "success" | "warning";
  onClose;
  onClick;
}

function ModalWithAction(props: ModalProps) {
  const {
    isModalOpen,
    title,
    subtitle,
    cancelButtonTitle,
    actionButtonTitle,
    onClose,
    onClick,
  } = props;
  const isDark = useDarkMode();

  let icon;
  let borderColor;

  switch (props.type) {
    case "success":
      borderColor = "#10B981"; // Green color for success
      icon = <CheckCircle size={24} color={isDark ? "#6EE7B7" : borderColor} />;
      break;
    case "error":
      borderColor = "#F87171"; // Red color for error
      icon = <Trash2 size={24} color={isDark ? "#6EE7B7" : borderColor} />;
      break;
    case "warning":
      borderColor = "#F87171"; // Red color for error
      icon = <TriangleAlert size={24} color={isDark ? "#6EE7B7" : borderColor} />;
      break;      
    default:
      borderColor = "#352FC3"; // Blue color for default
      icon = <Info size={24} color={isDark ? "#A39FE8" : borderColor} />;
      if (isDark) {
        borderColor = "#A39FE8";
      }
      break;
  }

  return (
    <Modal focusTrapped
      open={isModalOpen}
      onClose={onClose}
      classNames={{
        modal: "bg-transparent p-4 shadow-none",
        closeButton: "hidden",
      }}
    >
      <div
        style={{
          borderTopColor: borderColor,
          borderTopWidth: "10px",
        }}
        className="w-[327px] bg-white dark:bg-[#313A71] rounded-[10px] px-[16px] py-[12px] flex flex-col"
      >
        <div className="flex flex-row">
          <div className="w-8 h-8 mr-[8px]">{icon}</div>
          <div className="desktop-h3-small-semi-bold" tabIndex={0}>{title}</div>
        </div>
        <p className="paragraph-small-medium text-primary-900 dark:text-primary-100 py-4" tabIndex={0}>
          {subtitle}
        </p>

        <div className="flex flex-row items-end justify-end w-full mt-[8px]">
          {cancelButtonTitle != "" && (
            <button
              className="mr-[12px] px-[12px] py-[8px] h-[40px] rounded-[12px] border border-[#CBC9F2] button-regular-semi-bold text-primary-900 dark:text-primary-100"
              onClick={onClose}
            >
              {cancelButtonTitle}
            </button>
          )}
          <button
            style={{
              backgroundColor:
                props.actionButtonType === "error" || props.actionButtonType === "warning"  
                  ? "#991B1B"
                  : isDark
                    ? "#4640BE"
                    : "#19165C",
            }}
            onClick={onClick}
            className="px-[12px] py-[8px] h-[40px] rounded-xl text-white button-regular-semi-bold"
          >
            {actionButtonTitle}
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default ModalWithAction;
